import { render, staticRenderFns } from "./teamBuy.vue?vue&type=template&id=eb96e1e2&scoped=true"
import script from "./teamBuy.vue?vue&type=script&lang=js"
export * from "./teamBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb96e1e2",
  null
  
)

export default component.exports